import axios from 'frontend/_config/axios'
import setupRouter from 'frontend/_setup/setupRouter/setupRouter'
import { ResourceService } from 'frontend/common/services/resource-service'
import { SimpleSelectService } from 'frontend/common/services/simple-select-service'

export class VehicleTypesService extends ResourceService {
  constructor({
    eventSlug = setupRouter.currentRoute.value.params.eventSlug,
    baseUrl = eventSlug?.length ? `/events/${eventSlug}/vehicle_types` : `/vehicle_types`,
    blocker,
    fetchError = 'Failed to fetch vehicle types.',
    saveError = 'Failed to save vehicle type.',
    apiProvider = axios,
    selectService = new SimpleSelectService(baseUrl, {
      apiProvider,
      blocker,
      blockerKey: 'vehicle-types',
    }),
  } = {}) {
    super({
      apiProvider,
      baseUrl,
      blocker,
      fetchError,
      saveError,
    })
    this.selectService = selectService
  }

  // get getForSelect() {
  //   return this.selectService.fetchOptions
  // }
  getForSelect() {
    return (additionalPayload = {}) =>
      this.selectService.fetchOptions({
        additionalPayload,
        sorts: 'lower_name asc',
        fields: ['id', 'name'],
        path: `${this.selectService.baseUrl}/selection_index`,
      })
  }
}
